<template>
  <NuxtLayout name="search-basic-layout">
    <!--    h-[calc(100dvh-66px-1px-33px) nav:66px nav-border:1px 麵包屑:33px-->
    <div class="flex pc:h-[calc(100dvh-66px-1px-33px)]">
      <div v-if="!isMobile || isShowSpaceList"
           class="flex flex-col pc:w-1/2 mobile:w-full overflow-y-auto">

        <div class="border-b pc:pb-[16px] pc:mx-[30px] my-[16px] pc:flex pc:flex-wrap mobile:pb-[20px]">
          <div class=" w-full pc:flex pc:justify-between">
            <SearchBar :is-result="true"></SearchBar>

            <!--            <KeywordSearchBar v-if="!isMobile"></KeywordSearchBar>-->
          </div>

          <div class="mt-[12px] flex items-center">
            <DropdownSelectFilter v-if="!isMobile"
                                  class="mr-2"
                                  :filter-name="peopleFilterConfig.filterName"
                                  :option-list="peopleFilterConfig.optionList"
                                  :range-config="peopleFilterConfig.rangeConfig"
                                  :initial-range="peopleFilterConfig.initialRange"
                                  @update:selected-item="handlePeopleChange"></DropdownSelectFilter>
            <DropdownSelectFilter v-if="!isMobile"
                                  class="mr-2"
                                  :filter-name="priceFilterConfig.filterName"
                                  :option-list="priceFilterConfig.optionList"
                                  :range-config="priceFilterConfig.rangeConfig"
                                  :initial-range="priceFilterConfig.initialRange"
                                  @update:selected-item="handlePriceChange"></DropdownSelectFilter>
            <SearchFilter v-if="!isMobile"></SearchFilter>
          </div>


        </div>

        <div ref="searchResultTitleRes"
             class="flex flex-col">
          <div class="mb-[15px] flex items-center justify-between
          pc:pl-[30px] pc:pr-[20px] mobile:px-[16px] mobile:flex-wrap">
            <div class="relative flex items-baseline mobile:mb-4 mobile:min-w-full mobile:mt-2">
              <h3 class="text-osn-dark-grey-00 text-2xl font-bold mobile:text-xl">{{
                  isSeoText(seoType) ? getSeoTextByType(seoType).section1.resultTitle : $t('result.search_result')
                }}</h3>

              <div class="text-osn-grey-01 text-[16px] ml-[8px]">{{ $t('result.total', {t: total}) }}</div>
              <!-- 手機版 -->
              <div v-if="isMobile"
                   class="absolute top-[50%] translate-y-[-50%] right-0 text-osn-black-00 text-[16px] py-[4px] px-[12px] border border-solid border-osn-black-00 rounded-[20px]"
                   @click="isShowSpaceList = !isShowSpaceList">
                <div class="flex items-center">
                  <svg-icon :name="isShowSpaceList ? 'to_map' : 'to_list'"
                            size="20"
                            class="mr-[3px]"/>
                  {{ isShowSpaceList ? $t('map_list.to_map') : $t('map_list.to_list') }}
                </div>
              </div>
            </div>
            <div v-if="!isMobile || isShowSpaceList">
              <SearchResultsSorter></SearchResultsSorter>
            </div>
          </div>

          <!-- seo 文字 section0 -->
          <section v-if="isSeoTextComputed"
                   class="seo-section-0">
            <h1 class="seo-h1">{{ getSeoTextByType(seoType).section0.h1 }}</h1>
            <p class="seo-p">{{ getSeoTextByType(seoType).section0.p }}</p>
          </section>

          <div class="relative h-full">
            <div v-if="!isMobile || isShowSpaceList"
                 class="">
              <div v-if="total === 0"
                   class="mt-[120px] w-full text-[16px] text-osn-grey-01 flex items-center flex-col">
                <svg-icon name="magnifier"
                          size="40"></svg-icon>
                {{ $t('result.no_result') }}
                <div class="mt-[40px] mb-[20px] w-full font-bold text-[20px] text-osn-dark-grey-00 text-left">
                  {{ $t('result.recommend_space') }}
                </div>
                <!--                <div v-for="recommendSpaceInfo in recommendSpaceList"
                                     ref="recommendSpaceRefs">
                                  <SpaceCard :space-info="recommendSpaceInfo"></SpaceCard>
                                </div>-->
              </div>
              <SpaceListWrapper class="pc:ml-[30px] mobile:px-[15px]"></SpaceListWrapper>

              <div class="bg-osn-grey-04 pc:py-[18px] pc:px-11 mobile:p-[12px]">
                <!-- seo 文字 section1 -->
                <section v-if="isSeoTextComputed"
                         class="seo-section pc:mb-4">
                  <h2 class="seo-h2">
                    <svg-icon name="question_mark_fill"
                              size="20"
                              class="mr-1"/>
                    {{ getSeoTextByType(seoType).section1.h2 }}
                  </h2>
                  <p class="seo-p">{{ getSeoTextByType(seoType).section1.p }}</p>


                  <!--                  新補上價格-->
                  <ul v-if="getSeoTextByType(seoType).section1.priceList">
                    <li v-for="priceGroup in getSeoTextByType(seoType).section1.priceList"
                        :key="priceGroup.region"
                        class="mt-2">
                      <p class="text-[14px] font-bold text-osn-dark-grey-00">{{ priceGroup.region }}</p>
                      <ul class="list-disc list-inside mt-2 space-y-1 text-[12px]">
                        <li v-for="priceItem in priceGroup.prices"
                            :key="priceItem.type">
                          <span class="font-bold">{{ priceItem.type }}：</span>{{ priceItem.price }}
                        </li>
                      </ul>
                    </li>
                  </ul>


                </section>

                <!-- seo 文字 section2 -->
                <section v-if="isSeoTextComputed"
                         class="seo-section my-4 pt-2">
                  <h2 class="seo-h2">
                    <svg-icon name="question_mark_fill"
                              size="20"
                              class="mr-1"/>
                    {{ getSeoTextByType(seoType).section2.h2 }}
                  </h2>
                  <h3 v-if="getSeoTextByType(seoType).section2.h3" class="mt-2 ml-2">
                    {{ getSeoTextByType(seoType).section2.h3 }}
                  </h3>
                  <ul class="mt-4 list-disc ml-4">
                    <li v-for="item in getSeoTextByType(seoType).section2.list">
                      <p class="seo-h3">{{ item.p1 }}</p>
                      <p class="seo-p">{{ item.p }}</p>
                    </li>
                  </ul>
                </section>
                <!-- seo 文字 section2_1 -->
                <section v-if="isSeoTextComputed && getSeoTextByType(seoType)?.section2_1"
                         class="seo-section my-4 pt-2">
                  <ul class="mt-4 list-disc ml-4">
                    <li v-for="item in getSeoTextByType(seoType).section2_1.list"
                        :key="item.h3">
                      <h3 class="seo-h3">{{ item.h3 }}</h3>
                      <p class="seo-p">{{ item.p }}</p>
                    </li>
                  </ul>
                </section>

                <!-- seo 文字 section3 -->
                <section v-if="isSeoTextComputed"
                         class="seo-section mt-4 pt-2">
                  <h2 class="seo-h2">
                    <svg-icon name="question_mark_fill"
                              size="20"
                              class="mr-1"/>
                    {{ getSeoTextByType(seoType).section3.h2 }}
                  </h2>
                  <ul class="mt-4">
                    <li v-for="item in getSeoTextByType(seoType).section3.list">
                      <h3 class="seo-h3">{{ item.h3 }}</h3>
                      <p class="seo-p">{{ item.subTitle }}</p>
                      <ul class="list-disc">
                        <li v-for="ulItem in item.ul">{{ ulItem }}</li>
                      </ul>
                    </li>
                  </ul>
                </section>
              </div>


              <!-- seo 文字 section4 -->
              <section v-if="isSeoTextComputed"
                       class="seo-section-bottom pt-2 border-t bg-osn-yellow-00">

                <h2 class="seo-h2">{{ getSeoTextByType(seoType).section4.h2 }}</h2>
                <ul class="mt-4">
                  <li v-for="(item, idx) in getSeoTextByType(seoType).section4.list"
                      :key="item.title || idx">
                    <svg-icon :name="item.icon"
                              size="24"
                              class="pc:mb-2 mobile:flex-shrink-0 mobile:mr-[10px]"/>
                    <div>
                      <div class="seo-li-title">{{ item.title }}</div>
                      <p class="seo-p">{{ item.p }}</p>
                    </div>
                  </li>
                </ul>


              </section>
              <Footer></Footer>
            </div>
          </div>
        </div>
      </div>

      <!-- 右半邊的地圖 -->
      <div v-if="!isMobile || !isShowSpaceList"
           class="relative pc:w-1/2 mobile:w-full h-full mobile:h-[calc(100dvh-66px-1px-33px)]">
        <Map class="flex-1"></Map>
        <div v-if="isMobile"
             class="absolute top-[10px] right-[10px] text-osn-black-00 text-[16px] py-[4px] px-[12px] rounded-[20px] bg-white"
             @click="isShowSpaceList = true">
          <div class="flex items-center">
            <svg-icon name="to_list"
                      size="20"
                      class=""/>
            {{ $t('map_list.to_list') }}
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup
        lang="ts">

import {computed, nextTick, ref, onMounted, provide} from "vue";
import {useRouteQuery} from "@vueuse/router";
import SearchBar from "@/components/SearchIndex/SearchBarWrapper/SearchBar.vue";
import SearchFilter from "@/components/SearchResult/SearchFilter.vue";
import DropdownSelectFilter from "@/components/SearchResult/DropdownSelectFilter.vue";
import KeywordSearchBar from "@/components/SearchResult/KeywordSearch/KeywordSearchBar.vue";
import SearchResultsSorter from "@/components/SearchResult/SearchResultsSorter.vue";
import SpaceListWrapper from "@/components/SearchResult/SpaceList/SpaceListWrapper.vue";
import Map from "@/components/SearchResult/Map.vue";
import Footer from "@/components/Footer/Footer.vue";


import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {useSettingStore} from "@/stores/setting";
import {useSearchResultStore} from "@/stores/searchResult";
import {useQueryFormatter} from "@/composables/useQueryFormatter";
import {useSearchWithStore} from "@/composables/useSearchWithStore";
import {useI18n} from '#imports';
import {priceList, priceRange, peopleList, peopleCapRange} from "@/config/common.js";
import {getSeoText} from "@/config/seoText.js";

const {t} = useI18n();
const route = useRoute();
const router = useRouter()
const settingStore = useSettingStore()
const searchQueryStore = useSearchQueryStore()
const searchResultStore = useSearchResultStore()
const {handleSearchWithStore} = useSearchWithStore()
const {setSearchQueryRouteToStore} = useQueryFormatter()
const isMobile = computed(() => settingStore.isMobile);
const total = computed(() => searchResultStore.getSpaceListTotal);
// const recommendSpaceList = computed(() => searchResultStore.getRecommendSpaceList);

// const _usageCategoryId = useRouteQuery('_usageCategoryId')


/*const props = defineProps({
  seoType: {
    type: Array,
    default: []
  }
})*/

const props = defineProps<{
  seoType: string[]
}>()

const isSeoTextComputed = computed(() => isSeoText(props.seoType));


const priceFilterConfig = {
  filterName: t('menu.price'),
  optionList: priceList,
  rangeConfig: priceRange,
  initialRange: searchQueryStore.getPriceRange,
};
const handlePriceChange = (newValue) => {
  searchQueryStore.setSelectedPriceRange(priceFilterConfig.rangeConfig[newValue] || {});
  handleSearchWithStore()
};

const peopleFilterConfig = {
  filterName: t('menu.people'),
  optionList: peopleList,
  rangeConfig: peopleCapRange,
  initialRange: searchQueryStore.getPeopleCapRange,
};
const handlePeopleChange = (newValue) => {
  searchQueryStore.setSelectedPeopleCapRange(peopleFilterConfig.rangeConfig[newValue] || {});
  handleSearchWithStore()
};

const searchResultTitleRes = ref(null);
const isShowSpaceList = ref(true);

const layoutProps = {
  footer: false
};
provide('searchBasicLayoutProps', layoutProps);

onMounted(() => {
  slideTo();

  /* if (route.query.sid) {
     router.push({path: `/space/${route.query.sid}`})
   }

   slideTo();

   // 檢查是否有有效的查詢參數
   const hasValidQuery = (query) => query && Object.keys(query).length > 0;

   // 處理路由查詢參數的主邏輯
   const processRouteQuery = (query) => {
     setSearchQueryRouteToStore(query);
     handleSearchWithStore();
   };

   // 主執行流程
   if (hasValidQuery(route.query)) {
     processRouteQuery(route.query);
   }*/

})


function slideTo() {
  nextTick(() => {
    searchResultTitleRes.value.scrollIntoView();
  })
}

const isSeoText = (typeArray) => {

  /*
    // 防禦性檢查
    if (!Array.isArray(typeArray)) {
      // console.error('isSeoText Error: typeArray is not an array', typeArray);
      return false;
    }

    if (typeArray.length === 0) {
      return false;
    }*/

  return getSeoTextByType(typeArray)
  // return typeArray.some(type => Object.keys(seoMap).includes(String(type)));
};

const getSeoTextByType = (typeArray) => {
  if (!Array.isArray(typeArray) || typeArray.length === 0) {
    return null;
  }
  return getSeoText(typeArray[0]);
}


</script>

<style scoped
       lang="scss">
.seo-section-0 {
  @apply pc:mx-auto pc:pl-[30px] mb-5  px-5 mobile:text-base;
  .seo-h1 {
    @apply text-[20px] mobile:leading-[24px] font-bold;
  }

  .seo-p {
    @apply mt-4 text-[14px] text-osn-grey-01;
  }
}

.seo-section {
  @apply bg-osn-white-00 rounded-[20px] text-osn-grey-01
  pc:p-4
  mobile:p-[12px];

  .seo-h2 {
    @apply text-[14px] font-bold flex items-center text-osn-dark-grey-00;
  }

  .seo-p {
    @apply mt-2 text-[12px] mobile:text-[14px];
  }

  .seo-h3 {
    @apply mt-2 text-[12px] mobile:text-[14px];
  }

  ul {
    @apply mt-2;
    li {
      @apply ml-[12px] text-[12px];
      .seo-li-title {
        @apply font-bold;
      }
    }
  }
}

.seo-section-bottom {
  @apply py-[20px] text-osn-grey-01 pc:px-[30px] mobile:px-[12px];

  .seo-h2 {
    @apply font-semibold text-osn-dark-grey-00 text-[14px];
  }

  .seo-p {
    @apply mt-2;
  }

  ul {
    @apply mt-2 flex mobile:flex-wrap text-[12px];
    li {
      @apply w-1/3 mobile:w-full mt-2 mr-[30px] mobile:flex mobile:mb-[10px];
      .seo-li-title {
        @apply pc:mb-[10px] font-semibold text-osn-dark-grey-00;
      }
    }
  }
}

.space-list-wrap {
  @apply absolute w-[400px] top-0 bottom-0 left-1.5 z-50;
}
</style>
